import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { TrustBar } from '../components/TrustBar';
import { ShopByCategory } from '../components/ShopByCategory';
import { FeaturedProducts } from '../components/FeaturedProducts';
import { BrowseCollection } from '../components/BrowseCollection';
import { MemorabiliaBanner } from '../components/MemorabiliaBanner';
import { WhyBucknut } from '../components/WhyBucknut';
import { Newsletter } from '../components/Newsletter';
import { Footer } from '../components/Footer';
export const Home = () => {
  return <div className="min-h-screen flex flex-col w-full" data-id="element-157">
      <Header data-id="element-158" />
      <main className="flex-grow" data-id="element-159">
        <Hero data-id="element-160" />
        <TrustBar data-id="element-161" />
        <ShopByCategory data-id="element-162" />
        <FeaturedProducts data-id="element-163" />
        <BrowseCollection data-id="element-164" />
        <MemorabiliaBanner data-id="element-165" />
        <WhyBucknut data-id="element-166" />
        <Newsletter data-id="element-167" />
      </main>
      <Footer data-id="element-168" />
    </div>;
};